class YuanProductDetails extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
    this.enhanceTables();
  }

  enhanceTables() {
    this.querySelectorAll('.yuan-product-details__panel table').forEach((table) => {
      const firstRow = table.querySelector('tr');
      if (!firstRow) return;
      const alreadyWrapped = table.parentElement?.classList.contains('yuan-table-scroll');
      if (alreadyWrapped && table.classList.contains('yuan-table')) {
        const colCount = firstRow.children.length;
        if (colCount === 4) table.parentElement.classList.add('yuan-table-scroll--spec-split');
        if (colCount >= 5) table.parentElement.classList.add('yuan-table-scroll--chart');
        return;
      }
      if (alreadyWrapped) return;

      table.removeAttribute('style');
      table.removeAttribute('border');
      table.removeAttribute('cellpadding');
      table.removeAttribute('cellspacing');
      table.removeAttribute('width');
      table.querySelectorAll('td, th, tr, col, colgroup').forEach((cell) => {
        cell.removeAttribute('style');
        cell.removeAttribute('width');
        cell.removeAttribute('height');
        cell.removeAttribute('valign');
        cell.removeAttribute('align');
        cell.removeAttribute('bgcolor');
      });

      const colCount = firstRow.children.length;
      const wrap = document.createElement('div');
      wrap.className = 'yuan-table-scroll';
      table.classList.add('yuan-table');
      if (table.querySelector('thead')) table.classList.add('yuan-table--has-head');

      if (colCount === 2 || colCount === 4) {
        wrap.classList.add('yuan-table-scroll--spec');
        table.classList.add('yuan-table--spec');
        if (colCount === 4) wrap.classList.add('yuan-table-scroll--spec-split');
      } else {
        wrap.classList.add('yuan-table-scroll--chart');
        table.classList.add('yuan-table--chart');
        wrap.setAttribute('role', 'region');
        wrap.setAttribute('tabindex', '0');
        wrap.setAttribute('aria-label', 'جدول المواصفات');
      }

      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  onClick(event) {
    const tab = event.target.closest('[data-yuan-tab]');
    if (tab) this.activateTab(tab);
  }

  onKeydown(event) {
    const tab = event.target.closest('[data-yuan-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...this.querySelectorAll('[data-yuan-tab]')];
    const currentIndex = tabs.indexOf(tab);
    const nextIndex = this.nextTabIndex(event.key, currentIndex, tabs.length);
    event.preventDefault();
    this.activateTab(tabs[nextIndex]);
    tabs[nextIndex].focus();
  }

  nextTabIndex(key, currentIndex, tabCount) {
    if (key === 'Home') return 0;
    if (key === 'End') return tabCount - 1;
    if (key === 'ArrowLeft') return (currentIndex + 1) % tabCount;
    return (currentIndex - 1 + tabCount) % tabCount;
  }

  onBlockSelect(event) {
    const panel = event.target.closest('[data-yuan-panel]');
    if (!panel) return;
    const tab = this.querySelector(`[data-yuan-tab="${panel.dataset.yuanPanel}"]`);
    if (tab) this.activateTab(tab);
  }

  activateTab(activeTab) {
    this.querySelectorAll('[data-yuan-tab]').forEach((tab) => {
      const selected = tab === activeTab;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    this.querySelectorAll('[data-yuan-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.yuanPanel !== activeTab.dataset.yuanTab;
    });
    activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }
}

document.addEventListener('click', (event) => {
  const wishlistButton = event.target.closest('[data-yuan-wishlist]');
  if (!wishlistButton) return;
  const isActive = wishlistButton.getAttribute('aria-pressed') === 'true';
  wishlistButton.setAttribute('aria-pressed', String(!isActive));
  wishlistButton.setAttribute('aria-label', isActive ? wishlistButton.dataset.addLabel : wishlistButton.dataset.removeLabel);
});

if (!customElements.get('yuan-product-details')) {
  customElements.define('yuan-product-details', YuanProductDetails);
}
